export interface ClingVisualSettings {
  brightnessEffects: boolean;
  brightnessLevel: number;
  pitchGuide: boolean;
  pitchGuideLevel: number;
}

export const DEFAULT_CLING_VISUAL: ClingVisualSettings = {
  brightnessEffects: true,
  brightnessLevel: 70,
  pitchGuide: true,
  pitchGuideLevel: 80,
};

const STORAGE_KEY = 'cling-visual-settings';

export function loadClingVisualSettings(): ClingVisualSettings {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return DEFAULT_CLING_VISUAL;
    const parsed = JSON.parse(raw) as Partial<ClingVisualSettings>;
    return {
      brightnessEffects: parsed.brightnessEffects ?? DEFAULT_CLING_VISUAL.brightnessEffects,
      brightnessLevel: clampPct(parsed.brightnessLevel ?? DEFAULT_CLING_VISUAL.brightnessLevel),
      pitchGuide: parsed.pitchGuide ?? DEFAULT_CLING_VISUAL.pitchGuide,
      pitchGuideLevel: clampPct(parsed.pitchGuideLevel ?? DEFAULT_CLING_VISUAL.pitchGuideLevel),
    };
  } catch {
    return DEFAULT_CLING_VISUAL;
  }
}

export function saveClingVisualSettings(settings: ClingVisualSettings): void {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(settings));
  } catch {
    /* ignore */
  }
}

function clampPct(n: number): number {
  return Math.min(100, Math.max(0, Math.round(n)));
}
